import {
  getSaaSproviders,
  getAppDetailInfo,
  createOrder,
  getOrderByID,
  orderPayment,
  getAppPriceInfo
} from '@/api/payment'

import {
  fetchMyOrderInfoState
} from '@/api/myOrder'

const order = {
  state: {
  },
  actions: {
    GetSaaSProviders({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        getSaaSproviders(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetAppInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        getAppDetailInfo(data.eid, data.appKeyID, data.appVersion)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetAppPriceInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        getAppPriceInfo(data.eid, data.appKeyID, data.appVersion)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 订单生出
    CreateOrder({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        createOrder(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetOrder({ commit }, data) {
      return new Promise((resolve, reject) => {
        getOrderByID(data.eid, data.orderID)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    OrderPay({ commit }, data) {
      return new Promise((resolve, reject) => {
        orderPayment(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetOrderStatusEvent({ commit }, data) {
      return new Promise((resolve, reject) => {
        fetchMyOrderInfoState(data.eid, data.orderID)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  mutations: {
  }
};

export default order;



// WEBPACK FOOTER //
// ./src/store/modules/order.js